export { default as SText } from "./SText";
export { default as SLogo } from "./SLogo";
